<template>
  <v-stepper alt-labels v-model="currentStep" style="width: 100%">
    <v-toolbar flat color="secondary" height="72">
      <div class="text-h5 white--text">Installation and Setup</div>
    </v-toolbar>
    <v-stepper-header class="elevation-0 px-0 pt-3 pb-7">
      <v-stepper-step class="pa-0" :complete="online" step="1"
      >Install Connector</v-stepper-step>
      <v-divider class="mt-3"/>
      <v-stepper-step class="pa-0" :complete="online && licenseActive" step="2"
      >Activate License</v-stepper-step>
      <v-divider class="mt-3"/>
      <v-stepper-step class="pa-0" :complete="online && licenseActive && labInstalled" step="3"
      >Install Labs</v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1" class="pt-0">
        <v-card class="pa-2 elevation-0">
          <p>Install and launch Beyond Labz Connect. It makes all the labs work together and with
            your computer.
          </p>
          <p>
            <strong><em> New Users: </em></strong> Download and install Beyond Labz Connect,
            start it, and then click on the Connect button below.
          </p>
          <p>
            <strong><em> Existing Users: </em></strong> Click on the Connect button below to start
            Beyond Labz Connect and initiate the connection.
          </p>
        </v-card>
        <v-row class="px-6">
          <v-btn color="primary" elevation="0" to="/downloads"
          ><v-icon class="mr-2">mdi-download</v-icon>Download</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" elevation="0" @click="enableTarget">
            <v-icon class="mr-2">mdi-lan-connect</v-icon
            >Connect<v-progress-circular
            v-if="buttonDisabled"
            style="position: absolute;"
            indeterminate
            color="secondary"
          ></v-progress-circular></v-btn>
        </v-row>
      </v-stepper-content>
      <v-stepper-content step="2" class="pt-0">
        <v-card class="pa-2 elevation-0">
          Go to the License Manager and purchase or activate your Beyond Labz software license.
        </v-card>
        <v-row class="px-6">
          <v-spacer></v-spacer>
          <v-btn  color="primary" elevation="0" to="/license">License</v-btn>
        </v-row>
      </v-stepper-content>
      <v-stepper-content step="3" class="pt-0">
        <v-card class="pa-2 elevation-0">
          Install all of the labs shown below that you would like to use. Once they are installed
          you can start the lab by clicking the icon for that lab or the Launch button below it.
          If you have trouble installing a lab, click Help.
        </v-card>
        <v-row class="px-6">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            elevation="0"
            @click="openLink('https://www.beyondlabz.com/support')"
          >Help</v-btn>
        </v-row>
      </v-stepper-content>
    </v-stepper-items>
    <v-dialog flat outlined max-width="480" v-model="connectionError">
      <v-card>
        <v-card-title class="justify-center">Connection Error</v-card-title>
        <v-container
          class="text-center"
        >Sorry, there appears to be a problem with your connection. Try clicking on Connect again,
          and if that does not work, try quitting Beyond Labz Connect and click Connect again.
        </v-container>
        <v-card-actions class="justify-center">
          <v-btn elevation="0" color="primary" @click="connectionError = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-stepper>
</template>

<script>
import { mapGetters } from 'vuex';
import PortalCustomProtocolDetection from '@/store/PortalCustomProtocolDetection';

export default {
  name: 'SetupWizard',
  props: [],
  data: () => ({
    buttonDisabled: false,
    connectionError: false,
  }),
  methods: {
    openLink(url) {
      window.open(url, '_blank');
    },
    enableTarget() {
      this.buttonDisabled = true;
      PortalCustomProtocolDetection.protocolCheck(
        `blz-client://?uid=${localStorage.sender}`,
      );
      window.setTimeout(() => {
        this.buttonDisabled = false;
        this.connectionError = !this.online;
        console.log('SetupWizard :: enableTarget :: connectionError', this.connectionError);
      }, 10000);
    },
  },
  computed: {
    ...mapGetters(['online', 'licenseActive', 'labs']),
    labInstalled() {
      return Object.values(this.labs).some((v) => v.installed);
    },
    currentStep() {
      if (!this.online) {
        return 1;
      }
      if (!this.licenseActive) {
        return 2;
      }
      return 3;
    },
  },
};
</script>

<style>
.v-stepper__step--active > .v-stepper__label {
  font-weight: bold;
}
</style>
